<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="col-sm-12 list-container nopads">
    <Transition name="fade">
      <div
        v-if="resultList.length > 0"
        id="accordion"
        class="col-sm-12 list-content result-table"
      >
          <vue3-datatable
              ref="resultTable"
              :rows="resultList"
              :columns="fields"
              :pagination="false"
              :sticky-header="true"
              :height="resultList.length > 7 ? '53.5em' : '100%'"
              :sortable="true"
              skin="bh-table-compact"
              :row-class="getRowClass"
              cell-class="routa-table-cell"
              :has-checkbox="hasCheckbox"
              @row-click="emitEdit"
              @row-select="onRowSelect"
          >
              <template #empty>
                  <div class="text-center my-2">
                      {{ $t('common.no_results') }}
                  </div>
              </template>
              <template #created="row">
                  {{ row.value && row.value.created ? getShortDateString(row.value.created) : '' }}
              </template>
              <template #status="data">
                    <span :class="statusClass(data.value.status)">
                        {{ getStatusString(data.value.status) }}
                    </span>
              </template>
              <template #archived="row">
                  <div v-if="row.value.archived" class="col-12 d-flex justify-content-center nopads" style="color: #7FC000">
                      <i class="fa fa-check"></i>
                  </div>
              </template>
              <template #priority_value="data">
                    <span :class="priorityClass(data.value.priority_value)">
                        {{ getPriorityString(data.value.priority_value) }}
                    </span>
              </template>
              <template #photo="data">
                    <span class="nopads" @click.stop="$emit('showPhotos', data.value.id)">
                        <font-awesome-icon
                            v-if="data.value.photo_count && data.value.photo_count > 0"
                            icon="camera"
                            class="row-icon"/>
                    </span>
              </template>
              <template #links="data">
                <span v-if="data.value.observation" class="nopads">
                    <font-awesome-icon icon="location-pin" style="font-size: 1.2em; color: #003956;"/>
                </span>
              </template>
              <template #comments="data">
                <span class="icon-badge-wrapper" v-if="data.value?.comments > 0">
                    <font-awesome-icon icon="comment" class="row-icon" />
                    <span class="badge">{{ data.value.comments }}</span>
                </span>
              </template>
          </vue3-datatable>
      </div>
    </Transition>
  </div>
</template>

<script>
import {timeUtils} from '../mixins/TimeUtils'
import {workAssignmentHelper} from '../mixins/WorkAssignmentMixin'
import Vue3Datatable from "@bhplugin/vue3-datatable";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
    name: 'WorkAssignmentList',
    components: {FontAwesomeIcon, Vue3Datatable},
    mixins: [timeUtils, workAssignmentHelper],
    props: {
        results: {
            type: Array,
            default: function () {
                return []
            }
        },
        isObserver: Boolean,
        isAdmin: Boolean,
        selectedIds: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data() {
        return {
            sortBy: 'created',
            sortDesc: false,
            selectedRowId: null,
            selectedIndex: null,
            resultList: []
        }
    },
    computed: {
        hasCheckbox() {
            return this.isObserver || this.isAdmin
        },
        fields() {
            return [
                {field: 'id', title: this.$t('work_assignment.id'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'task', title: this.$t('work_assignment.task'), sort: true, headerClass: 'routa-table-header', minWidth: '15em'},
                {field: 'created', title: this.$t('work_assignment.created_time'), sort: true, type: 'date', headerClass: 'routa-table-header'},
                {field: 'created_by', title: this.$t('work_assignment.creator'), sort: true, headerClass: 'routa-table-header'},
                {field: 'assigned_to', title: this.$t('work_assignment.assigned_to'), sort: true, headerClass: 'routa-table-header'},
                {field: 'assigned_to_company', title: this.$t('relationships.main_contractor'), sort: true, headerClass: 'routa-table-header'},
                {field: 'status', title: this.$t('orders.status'), sort: true, headerClass: 'routa-table-header'},
                {field: 'archived', title: this.$t('observation_list.archived'), sort: true, headerClass: 'routa-table-header'},
                {field: 'priority_value', title: this.$t('work_assignment.select_priority'), sort: true, headerClass: 'routa-table-header'},
                {field: 'closing_date', title: this.$t('work_assignment.closed_time'), sort: true, type: 'date', headerClass: 'routa-table-header'},
                {field: 'work_time', title: this.$t('work_assignment.work_time'), sort: true, type: 'number', headerClass: 'routa-table-header'},
                {field: 'ass_info', title: this.$t('area_report_details.info'), sort: false, headerClass: 'routa-table-header', minWidth: '15em'},
                {field: 'photo', title: '', sort: false, headerClass: 'routa-table-header'},
                {field: 'links', title: '', sort: false, headerClass: 'routa-table-header'},
                {field: 'comments', title: '', sort: false, headerClass: 'routa-table-header'},
            ]
        }
    },
    watch: {
        results() {
            this.initTableItems()
        }

    },
    created() {
        // Plain (non-reactive) instance flag used to suppress row-select emission
        // while checkbox state is being re-applied programmatically.
        this._syncingSelection = false
    },
    mounted() {
        this.initTableItems()
    },
    methods: {
        initTableItems() {
            // Convert to table items
            let temp = [];
            this.resultList = [];
            this.results.forEach(item => {
                temp.push({
                    ...item, // Spread the original item properties
                    'task': this.getTitle(item),
                    'created_by': item.created_by ? `${item.created_by.last_name} ${item.created_by.first_name}` : '',
                    'assigned_to': item.assigned_to ? `${item.assigned_to.last_name} ${item.assigned_to.first_name}` : '',
                    'assigned_to_company': item.assigned_company ? item.assigned_company.name : '',
                    'status': item.status,
                    'archived': item.archived,
                    'priority_value': item.priority_value,
                    'closing_date': item.closing_date ? this.getDateString(item.closing_date) : '',
                    'ass_info': this.getAssignmentInfo(item)
                });
            });
            // Set table items and scroll to selected
            this.$nextTick(() =>  {
                this.resultList = temp
                this.$nextTick(() =>  {
                    this.scrollToSelected()
                    this.applySelection()
                })
            });
        },
        emitEdit: function (details) {
            this.selectedRowId = details.id
            this.selectedIndex = this.results.findIndex(item => item.id === details.id)
            this.$emit('edit', details.id)
        },
        getProgressValue(item) {
            if (item.progress_value) {
                return item.progress_value + " %"
            } else if (item.status === this.COMPLETED) {
                return "100 %"
            } else {
                return '-'
            }
        },

        getRowClass(row) {
            return row.id === this.selectedRowId ? 'routa-table-row selected-row row-id-' + row.id : 'routa-table-row  row-id-' + row.id
        },

        setSelection(index) {
            this.selectedRowId = null
            if (index >= 0 && index < this.results.length) {
                this.selectedRowId = this.results[index].id
            }
        },

        resetSelection() {
            this.selectedRowId = null
            this.selectedIndex = null
            this.$refs.resultTable?.clearSelectedRows()
        },

        applySelection() {
            if (!this.hasCheckbox) return
            this._syncingSelection = true
            this.$nextTick(() => {
                this.selectedIds.forEach(id => {
                    const idx = this.resultList.findIndex(item => item.id === id)
                    if (idx !== -1) {
                        this.$refs.resultTable.selectRow(idx)
                    }
                })
                this._syncingSelection = false
            })
        },

        onRowSelect(selectedRows) {
            if (this._syncingSelection) return
            const selectedIds = selectedRows.map(r => r.id)
            const originalItems = this.results.filter(a => selectedIds.includes(a.id))
            this.$emit('row-select', originalItems)
        },

        scrollToSelected() {
            let rowElement
            if (this.selectedRowId) {
                rowElement = document.querySelector(`.row-id-${this.selectedRowId}`)
                if (!rowElement) {
                    // Check if we have something in the index - observation closing case -> need to return to same place in list
                    if (this.selectedIndex && this.selectedIndex >= 0) {
                        this.selectedIndex = Math.min(this.selectedIndex, this.results.length)
                        const scrollId = this.results[this.selectedIndex].id
                        rowElement = document.querySelector(`.row-id-${scrollId}`)
                    }
                }
            }
            if (rowElement) {
                rowElement.scrollIntoView({ behavior: 'auto', block: 'center' })
            } else {
                this.resetSelection()
            }
        }

    }
}
</script>

<style scoped lang="css">

.icon-badge-wrapper {
    position: relative;
    display: inline-block;
    margin-right: 1em;
}

.badge {
    position: absolute;
    top: -4px;
    right: -6px;
    background: #A4D300;
    color: #0b4b8f;
    border-radius: 50%;
    padding: 1px 5px;
    font-size: 10px;
    font-weight: bold;
    line-height: 1;
}
</style>
